'use client';

import { Disclosure, Transition } from '@headlessui/react';
import { PlusIcon } from '@heroicons/react/24/solid';

type Props = {
  answer: string;
  question?: string;
};
export const FAQ = ({ answer, question }: Props) => {
  return (
    <Disclosure>
      <div className="flex flex-col gap-0.5 bg-blend-overlay">
        <Disclosure.Button className="flex justify-between bg-background-secondary p-4 text-base lg:text-lg">
          {question}
          <PlusIcon className="m-0 w-8 ui-open:rotate-45 ui-open:transform" />
        </Disclosure.Button>
        <div className="overflow-hidden">
          <Transition
            enter="transition duration-200 ease-out"
            enterFrom="transform -translate-y-12 "
            enterTo="transform translate-y-0"
            leave="transition duration-100 ease-out"
            leaveFrom="transform translate-y-0"
            leaveTo="transform -translate-y-12"
          >
            <Disclosure.Panel className="bg-faq-background mb-1 p-4">
              {answer}
            </Disclosure.Panel>
          </Transition>
        </div>
      </div>
    </Disclosure>
  );
};
